import { render, staticRenderFns } from "./CommentPraiseInfo.vue?vue&type=template&id=674b9e7b&scoped=true&"
import script from "./CommentPraiseInfo.vue?vue&type=script&lang=js&"
export * from "./CommentPraiseInfo.vue?vue&type=script&lang=js&"
import style0 from "./CommentPraiseInfo.vue?vue&type=style&index=0&id=674b9e7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674b9e7b",
  null
  
)

export default component.exports